import React, { Component } from 'react';
import Link from 'next/link';
import {
  Header,
  Icon,
  Image,
  Label,
  List,
  Pagination,
  Segment,
} from 'semantic-ui-react';

import CustomContainer from '../../common/CustomContainer';
import { formatDatetime } from '../../Utils';

export const Post = ({
  isMobile,
  post,
  showAuthor,
  showForum,
}) => (
  <List.Item
    key={post.id}
    // TODO -> shouldn't hard code this path
    as={Link}
    href={`/dcard/post/${post.id}`}
  >
    {
      showForum
      && (
      <List.Content floated="right">
        <Label
          size={isMobile ? 'tiny' : 'small'}
          color="teal"
        >
          {post.forum.name}
          {' '}
          (
          {post.forum.alias}
          )
        </Label>
      </List.Content>
      )
    }
    <List.Content style={{ paddingTop: '4px' }}>
      <List.Header>
        {post.title}
      </List.Header>
      <List.Description>
        <Icon name="calendar outline" />
        {formatDatetime(post.created_at)}
      </List.Description>
      {
        showAuthor && (
          <List.Description>
            {
              post.gender === 'M' ? (
                <Icon name="male" color="blue" />
              ) : (
                <Icon name="female" color="pink" />
              )
            }
            {
              post.school_meta && (
                <span>
                  {post.school_meta.name}
                  {' '}
                  {post.department}
                </span>
              )
            }
            {
              post.persona_meta && (
                <span>
                  {post.persona_meta.nickname ?? post.persona_meta.id}
                </span>
              )
            }
          </List.Description>
        )
      }
    </List.Content>
    <List.Content floated="right">
      <Icon color="orange" name="comment alternate outline" />
      {post.num_comments}
    </List.Content>
    {
      Array.isArray(post.reactions) && (
        post.reactions.map((r) => (
          <List.Content floated="right">
            <Image
              src={r.link}
              circular
              inline
              verticalAlign="bottom"
              style={{
                width: isMobile ? '16px' : '18px',
              }}
            />
            {' '}
            {r.count}
          </List.Content>
        ))
      )
    }
  </List.Item>
);

export default class Posts extends Component {
  onPageChange = (e, { activePage }) => this.props.fetchFunc(activePage);

  render() {
    const {
      data,
      isFetching,
      isMobile,
      offset,
      pageSize,
      title,
      total,
      showAuthor = false,
      showForum = false,
    } = this.props;

    const n = data.length;

    if (n === 0 && !isFetching) {
      return (null);
    }

    return (
      <CustomContainer>
        <Header as={isMobile ? 'h3' : 'h2'} attached="top">
          {title || '所有文章'}
        </Header>
        <Segment
          attached
          loading={isFetching}
        >
          <List
            animated
            divided
            relaxed
            selection
            size={isMobile ? 'medium' : 'large'}
          >
            {
              data.map((post) => (
                <Post
                  isMobile={isMobile}
                  post={post}
                  showAuthor={showAuthor}
                  showForum={showForum}
                />
              ))
            }
          </List>
          {
            total > 1 && (
              <Pagination
                boundaryRange={isMobile ? 0 : 3}
                defaultActivePage={(offset / pageSize) + 1}
                ellipsisItem={isMobile ? null : '...'}
                firstItem={null}
                lastItem={null}
                siblingRange={1}
                totalPages={total}
                disabled={isFetching}
                onPageChange={this.onPageChange}
              />
            )
          }
        </Segment>
      </CustomContainer>
    );
  }
}
